var virgin = {
    actionButton: {
        text: 'shopMore.virginButtonText',
        link: 'https://virginredrewardscard.syf.com/benefits'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    en: {
        termsAndConditionsLink: 'https://apply.syf.com/cs/groups/public/documents/et_statusdoc/e074600.html'
    },
    es: {
        termsAndConditionsLink: 'https://apply.syf.com/cs/groups/public/documents/et_statusdoc/e074600.html'
    },
    howToEarnPointsHeader: 'fullDetailsPage.virginHowToEarnPointsHeader',
    faqs: null,
    faqsSnapshot: false,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationKey: 'faqs.virginDescription',
    snapshotTranslationKey: 'faqs.description',
    translationViewPrintKey: null,
    DUAL_CARD: {
        banner: 'virgin-dc-banner.jpg',
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {
                virginPurchases: {
                    icon: ['far', 'credit-card']
                },
                dineGroEVStream: {
                    icon: ['far', 'bag-shopping']
                },
                baseEarn: { icon: ['far', 'earth-america'] },
                Bonus: { icon: ['far', 'money-bills'] },
                earnedLastCycle: { icon: null }
            },
            titleKey: 'virginEarnings.yourVirginEarnings'
        },
        perks: [
            {
                icon: ['far', 'bed-front'],
                titleTranslationKey: 'extraNightTitle',
                descriptionTranslationKey: 'extraNightDescription'
            },
            {
                icon: ['far', 'plane'],
                titleTranslationKey: 'flyAndEarnTitle',
                descriptionTranslationKey: 'flyAndEarnDescription'
            },
            {
                icon: ['far', 'party-horn'],
                titleTranslationKey: 'earnBonusPointsTitle',
                descriptionTranslationKey: 'earnBonusPointsDescription'
            }
        ],
        rewardsBalance: true,
        valuePropImg: '',
        en: {
            propositions: [
                {
                    description: 'Earn 3 Virgin Points for every $1 you spend with Virgin Atlantic, Virgin Hotels, and Virgin Voyages.',
                    heading: 'earn',
                    points: '3 points'
                },
                {
                    description: 'Earn 2 Virgin Points for every $1 you spend at grocery stores, dining out, on select streaming services, and charging your EV.',
                    heading: 'earn',
                    points: '2 points'
                },
                {
                    description: 'Earn 1 Virgin Point for every $1 you spend on everything else, anywhere Mastercard® is accepted.',
                    heading: 'earn',
                    points: '1 point'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 3 Puntos Virgin por cada $1 que gaste con Virgin Atlantic, Virgin Hotels y Virgin Voyages.',
                    heading: 'obtenga',
                    points: '3 puntos'
                },
                {
                    description: 'Obtenga 2 Puntos Virgin por cada $1 que gaste en supermercados, restaurantes, servicios de transmisión en directo y cargas de EV (Vehículos Eléctricos).',
                    heading: 'obtenga',
                    points: '2 puntos'
                },
                {
                    description: 'Obtenga 1 Punto Virgin por cada $1 que gaste en cualquier otra cosa, en cualquier lugar donde se acepte Mastercard®.',
                    heading: 'obtenga',
                    points: '1 punto'
                }
            ]
        }
    }
};
export default virgin;
